import React, {useState, useRef, useEffect} from 'react';
import {useSelector} from 'react-redux';

// Utils
import {getOffset} from 'Utils';

const Line = (props) => {
    const execute = useRef(null);
    const [coordinates, setCoordinates] = useState('');

    const getPosition = (nodeIdToGo, nodeIdToCome, offsetContainer = {}) => {
        // 2110 2109

        const target1 = document.getElementById(`node_${nodeIdToGo}`);
        const target2 = document.getElementById(`node_${nodeIdToCome}`);

        const headerHeight = offsetContainer.top;
        const paddingLeft = offsetContainer.left;

        if (target1 && target2) {
            const width1 = target1.offsetWidth;
            const height1 = target1.offsetHeight;
            const rect1 = getOffset(target1);

            let top1 = rect1.top - headerHeight - (height1 / 2);
            let left1 = rect1.left - paddingLeft + width1;

            const width2 = target2.offsetWidth;
            const height2 = target2.offsetHeight;
            const rect2 = getOffset(target2);
            let top2 = rect2.top - headerHeight + (height2 / 2);

            let left2 = rect2.left - paddingLeft;

            let bezierPoint1, bezierPoint2;

            top1 = top1 + height1;

            if (top1 > top2) {
                bezierPoint1 = [left1 + 100, top1 - 100];
                bezierPoint2 = [left2 - 100, top2 + 100];
            } else {
                bezierPoint1 = [left1 + 100, top1 + 100];
                bezierPoint2 = [left2 - 100, top2 - 100];
            }
            const d = `M ${[left1, top1]} C ${bezierPoint1} ${bezierPoint2} ${[left2, top2]}`;

            return d;
        }

        return '';
    };

    useEffect(() => {
        execute.current = setTimeout(() => {
            const newCoordinates = getPosition(props.nodeIdToGo, props.nodeIdToCome, props.offsetContainer);

            if (newCoordinates !== coordinates) {

                setCoordinates(newCoordinates);
            }
        }, 200);

        return () => {
            if (execute.current) {
                clearTimeout(execute.current);
            }
        };
    });

    return <>
        <defs>
            <marker id={`head-${props.nodeIdToGo}-edge-2-goToAction-${props.index}-path`} orient="auto" markerWidth={20} markerHeight={15} refX={4} refY="2.5"><path d="M0,0 V5 L5,2 Z" fill="#999999" />
            </marker>
        </defs>
        <path
            d={coordinates}
            strokeDasharray="5,3"
            strokeWidth={2}
            markerEnd={`url(#head-${props.nodeIdToGo}-edge-2-goToAction-${props.index}-path)`} fill="none" stroke="#999999"
        />
    </>;
};

export default Line;
